import * as React from 'react';

function SubscriptionInfo() {
	return (
		<svg
			xmlns={'http://www.w3.org/2000/svg'}
			width={'21'}
			height={'20'}
			viewBox={'0 0 21 20'}
			fill={'none'}
		>
			<g id={'info-circle'}>
				<path
					id={'Icon'}
					d={
						'M10.5001 13.3332V9.99984M10.5001 6.6665H10.5084M18.8334 9.99984C18.8334 14.6022 15.1025 18.3332 10.5001 18.3332C5.89771 18.3332 2.16675 14.6022 2.16675 9.99984C2.16675 5.39746 5.89771 1.6665 10.5001 1.6665C15.1025 1.6665 18.8334 5.39746 18.8334 9.99984Z'
					}
					stroke={'#C58820'}
					strokeWidth={'1.66667'}
					strokeLinecap={'round'}
					strokeLinejoin={'round'}
				/>
			</g>
		</svg>
	);
}

export default SubscriptionInfo;
